import { ControllerRenderProps, FieldValues } from 'react-hook-form';
import React, { Fragment } from 'react';

import { isNumberInputKey } from '../utils/inputKeyUtils';
import { padStart } from '../utils/stringUtils';

interface IndexInputProps {
	field: ControllerRenderProps<FieldValues, string>;
	label: string;
	value?: number;
}
function IndexInput({ value, label, field }: IndexInputProps) {
	const processedValue =
		value !== undefined
			? padStart(
					value.toFixed(1),
					7 - value.toFixed(1).replace('.', '').length
			  ).replace('.', '')
			: undefined;

	return (
		<div>
			{processedValue && (
				<Fragment>
					<div className='form-label d-xxl-none'>{label}</div>
					<div className='index-input index-input--disable'>
						{processedValue.split('').map((item, index) => (
							<div
								key={index}
								className={
									'form-control index-input__item ' +
									(index === 0 ? 'index-input__item--first' : '') +
									(index === processedValue.length - 1
										? 'index-input__item--last'
										: '')
								}
							>
								{(item === '0' &&
								index <
									processedValue.length - value!.toString()!.split('')?.length
									? ''
									: item) ||
									(item === '0' && index === 5 && processedValue === '0000000'
										? '0'
										: '')}
							</div>
						))}
					</div>
				</Fragment>
			)}
			{!processedValue && (
				<Fragment>
					<label htmlFor={field.name} className='form-label d-xxl-none'>
						{label}
					</label>
					<div className='index-input index-input--active'>
						<input
							data-test-id='index-input'
							id={field.name}
							autoComplete='off'
							className='index-input__reel-input'
							type='number'
							onKeyDown={isNumberInputKey}
							{...field}
							maxLength={6}
						></input>

						{[...Array(7)].map((_, index) => (
							<div
								key={index}
								className={
									'form-control index-input__item index-input__item--active ' +
									(index === 0 ? 'index-input__item--first' : '') +
									(index === 6 ? 'index-input__item--last' : '')
								}
							>
								{index === 6 ? 0 : ''}
							</div>
						))}
					</div>
				</Fragment>
			)}
		</div>
	);
}

export default IndexInput;
